import ico_patient from '../assets/New folder (2)/ico_patient.png';
import ico_doctor from '../assets/New folder (2)/ico_doctor.png';
import ico_office from '../assets/New folder (2)/ico_office.png';
import ico_nurse from '../assets/New folder (2)/ico_nurse.png';
import ico_manager from '../assets/New folder (2)/ico_manager.png';
import ico_bill from '../assets/New folder (2)/ico_bill.png';
import ico_payer from '../assets/New folder (2)/ico_payer.png';
import ico_admin from '../assets/New folder (2)/ico_admin.png';
//--------------
import Automated_processes_to_save_time from '../assets/LP/Automated_processes.png'
import Customization_for_Saudi_Businesses from '../assets/LP/Customization_for_Saudi_Businesses.png'
import Ideal_for_businesses_of_all_sizes from '../assets/LP/Ideal_for_businesses_of_all_sizes.png'
import Compliant_with_local_data from '../assets/LP/Compliant_with_local_data.png'


export const products_last_part = [
    {
        title : 'Patients',
        img : ico_patient,
        description :
        `Maximize quality of healthcare service
        Increased satisfaction and loyalty
        Patient data is secured without duplication
        Easy engagement with service providers
        Allows rural residents to receive expert diagnosis
        and treatment from distant medical centers.`,
    },
    {
        title : 'Physicians',
        img : ico_doctor,
        description :
        `Increased productivity
        Improve accuracy of diagnosis / treatment.
        Easy access of patient’s data anywhere / anytime
        Engage more with patients condition
        Share / consult with others remotely`,
    },
    {
        title : 'Operators',
        img : ico_office,
        description :
        `Increase productivity and efficiency
        Decrease waiting queues at reception
        Handle shift closing/opening more easy.
        Access patient records more easy for more coordinated, efficient care.`,
    },
    {
        title : 'Nurses',
        img : ico_nurse,
        description :
        `Increase productivity
        Maximize quality of care.
        Never miss a dose or a patient.
        Enable quick access to patient records for more coordinated, efficient care`,
    },
    {
        title : 'Managers',
        img : ico_manager,
        description :
        `Increased profitability and maximize ROI
        Maximize operation efficiency
        Improve decision making and forecasting
        Improve competitive advantage for the organization`,
    },
    {
        title : 'Financials',
        img : ico_bill,
        description :
        `Increased profitability and maximize ROI
        Consolidate financial calculations for different sites from one place.
        manage income statements , cash flow and balance sheets .`,
    },
    {
        title : 'Payers',
        img : ico_payer,
        description :
        `Get accurate financial data on the claims
        Automated processing of claims request and approval workflow.`,
    },
    {
        title : 'IT Administrators',
        img : ico_admin,
        description :
        `Centralized administration from anywhere. and across multiple environments.
        Easy tracking and auditing of daily transactions for more security and smooth operation.
        Improves administration efficiency`,
    },
]
export const products_last_part_2 = [
    {
        title : 'Benefit to Business Efficiency',
        img : Automated_processes_to_save_time,
        description :
        `Automated processes to save time.`,
    },
    {
        title : 'Customization for Saudi Businesses',
        img : Customization_for_Saudi_Businesses,
        description :
        `“Localized for Saudi Arabic language and specific business needs.`,
    },
    {
        title : 'Scalable Solutions',
        img : Ideal_for_businesses_of_all_sizes,
        description :
        `Ideal for businesses of all sizes.`,
    },
    {
        title : 'Security and Data Protection',
        img : Compliant_with_local_data,
        description :
        `Compliant with local data protection laws.`,
    },
    {
        title : 'Nurses',
        img : ico_nurse,
        description :
        `Increase productivity
        Maximize quality of care.
        Never miss a dose or a patient.
        Enable quick access to patient records for more coordinated, efficient care`,
    },
    {
        title : 'Managers',
        img : ico_manager,
        description :
        `Increased profitability and maximize ROI
        Maximize operation efficiency
        Improve decision making and forecasting
        Improve competitive advantage for the organization`,
    },
    {
        title : 'Financials',
        img : ico_bill,
        description :
        `Increased profitability and maximize ROI
        Consolidate financial calculations for different sites from one place.
        manage income statements , cash flow and balance sheets .`,
    },
    // {
    //     title : 'Payers',
    //     img : ico_payer,
    //     description :
    //     `Get accurate financial data on the claims
    //     Automated processing of claims request and approval workflow.`,
    // },
    {
        title : 'IT Administrators',
        img : ico_admin,
        description :
        `Centralized administration from anywhere. and across multiple environments.
        Easy tracking and auditing of daily transactions for more security and smooth operation.
        Improves administration efficiency`,
    },
]